import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ConcurrentExperience, ExperiencePerformanceTypes, ExperienceTypes } from '@atlaskit/ufo';
import { getFeatureFlagKeysAllProducts } from '@atlaskit/media-common';
import { getMediaEnvironment, getMediaRegion } from '@atlaskit/media-client';
var packageName = "@atlaskit/media-picker";
var packageVersion = "66.2.1";
var ufoExperience;
var initExperience = function initExperience(id, componentName) {
  if (!ufoExperience) {
    var inlineExperience = {
      platform: {
        component: "media-picker-".concat(componentName)
      },
      type: ExperienceTypes.Experience,
      performanceType: ExperiencePerformanceTypes.InlineResult,
      featureFlags: getFeatureFlagKeysAllProducts()
    };
    ufoExperience = new ConcurrentExperience('media-upload', inlineExperience);
  }
  return ufoExperience.getInstance(id);
};
var getExperience = function getExperience(id) {
  if (ufoExperience) {
    return ufoExperience.getInstance(id);
  }
};
export var startMediaUploadUfoExperience = function startMediaUploadUfoExperience(id, componentName) {
  initExperience(id, componentName).start();
};
export var succeedMediaUploadUfoExperience = function succeedMediaUploadUfoExperience(id, properties) {
  var _getExperience;
  (_getExperience = getExperience(id)) === null || _getExperience === void 0 ? void 0 : _getExperience.success({
    metadata: {
      fileAttributes: properties,
      packageName: packageName,
      packageVersion: packageVersion,
      mediaEnvironment: getMediaEnvironment(),
      mediaRegion: getMediaRegion()
    }
  });
};
export var failMediaUploadUfoExperience = function failMediaUploadUfoExperience(id, properties) {
  var _getExperience2;
  var refinedMetadata = _objectSpread(_objectSpread({}, properties), {}, {
    packageName: packageName,
    packageVersion: packageVersion,
    mediaEnvironment: getMediaEnvironment(),
    mediaRegion: getMediaRegion()
  });
  (_getExperience2 = getExperience(id)) === null || _getExperience2 === void 0 ? void 0 : _getExperience2.failure({
    metadata: refinedMetadata
  });
};